module.exports = __webpack_public_path__ + "static/media/guzelliklerburada.98e93661.png";